import type { CentrifugeMessage } from '../messageTypes';

export interface ExcelBroadcastMessageUnparsed {
  data: {
    type: 'ExcelBroadcast';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export interface ExcelBroadcastMessageMessage {
  stat: 'off' | 'on';
  bjList: { i: number; n: string }[];
  minCoin: number;
}

export interface ExcelBroadcastMessage {
  data: {
    type: 'ExcelBroadcast';
    message: ExcelBroadcastMessageMessage;
    created_at?: number;
  };
  offset: number;
}

export const isExcelBroadcastMessageUnparsed = (item: CentrifugeMessage): item is ExcelBroadcastMessageUnparsed => {
  return 'data' in item && item.data.type === 'ExcelBroadcast';
};

export const isExcelBroadcastMessage = (item: CentrifugeMessage): item is ExcelBroadcastMessage => {
  return 'data' in item && item.data.type === 'ExcelBroadcast';
};
